import { useEffect } from "react";

function Home() {

  useEffect(() => {
    // Animate step cards with stagger
    const cards = document.querySelectorAll(".step-card");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, idx) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("show");
              observer.unobserve(entry.target);
            }, idx * 150);
          }
        });
      },
      { threshold: 0.2 }
    );
    cards.forEach((card) => observer.observe(card));
  }, []);

return (
  <>
<header class="masthead">
  <div class="container px-4 px-lg-5 d-flex h-100 align-items-center justify-content-center">
    <div class="d-flex justify-content-center w-100 align-items-center">
      <div class="text-center justify-content-center w-100 pt-8">
        <h1 class="mx-auto my-0 text-uppercase w-100">ChatCGT</h1>
            <h3 className="text-center fs-6 text-white fw-bold">Simplifying your Capital Gains Tax file & pay process.</h3>
            <a 
      className="btn btn-lg btn-primary cta-button my-2 mb-5"
      href="https://chatcgt.typeform.com/to/rUw4Egui"
      target="_blank"
      >
      Check my CGT
    </a>

       

     <section id="projects">
      {/* Bottom row: large box */}
      <div className="row">
        <div className="col-12">
          <div className="info-box-large p-4">
          </div>
        </div>
      </div>
  <div className="container px-4 px-lg-5">
    {/* Top row: three square boxes */}
    <div className="row g-3">
      {[
        {
          title: 'How we help you',
          icon: (<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#64a19d" viewBox="0 0 16 16"><path d="M8 3.293l6 6V15a1 1 0 0 1-1 1h-4v-5H7v5H3a1 1 0 0 1-1-1V9.293l6-6z"/></svg>),
          text: 'Our service streamlines the entire CGT file and pay process from start to submission. We ensure you don’t incur penalties, fulfil obligations and pay the correct tax.',
          linktext: "our services",
          link: "/services"
        },
        {
          title: 'HMRC requirements',
          icon: (<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#64a19d" viewBox="0 0 16 16"><path d="M3 0h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm0 1v14h10V1H3zm2 2h6v1H5V3zm0 2h6v1H5V5zm0 2h4v1H5V7z"/></svg>),
          text: 'Sell an asset? You must file and pay within 60 days under HMRC rules. Get your calculations, reliefs and paperwork right to avoid penalties.',
          linktext: "HMRC penalties",
          link: "/info"

        },
        {
          title: 'CGT Made Hassle-Free',
          icon: (<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#64a19d" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.173 10.977l-2.482-2.482L2.823 9.364 6.173 12.7l7.207-7.207-1.354-1.354-5.853 5.838z"/></svg>),
          text: 'Sold an additional property? Calculate if you owe CGT sooner than you think – hassle-free guidance at your fingertips.',
          linktext: "CGT Made Hassle-Free",
          link: "/about"
        }
      ].map((block, idx) => (
        <div key={idx} className="col-12 col-md-4">
          <div className="info-box d-flex flex-column align-items-center justify-content-center p-3 h-100">
            {block.icon}
            <h4 className="mt-2 mb-1 text-center text-white fw-bold">{block.title}</h4>
            <p className="small text-center mb-0 text-white">{block.text}</p>
            <p className="small text-center mb-0 text-white fw-bold">Read more <a href={block.link}>here</a> about {block.linktext}</p>
          </div>
        </div>
      ))}
    </div>
        </div>

</section>


      </div>
    </div>
  </div>
    </header>

<section className="py-5 bg-default">
  <div className="container px-4 px-lg-5">
    <div className="steps-wrapper mx-auto mt-5">
      <div className="row gx-4 gy-4 justify-content-center text-start">
        {[...Array(5)].map((_, i) => (
          <div className="col-12 col-md-6 col-lg-4" key={i}>
            <div className="step-card">
              <div className="step-icon">{i + 1}</div>
              <h5>
                {[
                  "Smart Online Forms",
                  "Reliefs & Savings Check",
                  "Accurate Calculation",
                  "HMRC Registration Help",
                  "File & Pay Submission",
                ][i]}
              </h5>
              <p>
                {[
                  "Fill out our tailored forms to provide the most relevant details for your submission, quickly and easily.",
                  "We will identify any reliefs or exemptions available to reduce your tax liability.",
                  "Our accountants calculate your tax and deliver a clear summary via email and a phone call if needed.",
                  "We guide you step-by-step through HMRC's CGT registration process to appoint us as your agent.",
                  "We finalise your CGT calculations with you and complete your CGT submission to HMRC. You pay HMRC directly and we show you how to make your payment - we never handle your money.",
                ][i]}
              </p>
            </div>
          </div>
        ))}
      </div>

      <p className="steps-footnote mt-4 text-center text-white-80">
        All steps are completed well within your 60-day timeframe, with urgent
        cases handled immediately and confidentially.
      </p>
    </div>
  </div>
</section>

</>
  );
}

export default Home;
